var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_1346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.31247 3.60621C-0.852444 7.93233 -2.79099e-05 12.5279 -2.79099e-05 26.489C-2.79099e-05 38.0827 -2.02286 49.7052 8.56389 52.4413C11.8698 53.2915 41.1611 53.2915 44.4626 52.4369C48.8704 51.2996 52.4567 47.7243 52.947 41.4902C53.0154 40.6201 53.0154 12.3733 52.9448 11.4855C52.4236 4.84508 48.336 1.01804 42.9498 0.242917C41.7154 0.0640424 41.4681 0.0110424 35.1346 7.37607e-07C12.6692 0.0110424 7.7446 -0.989333 3.31247 3.60621Z",
    fill: "url(#paint0_linear_140_1346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4956 6.93197C18.4771 6.93197 10.8628 6.21868 7.95441 13.6828C6.75308 16.7657 6.92754 20.7694 6.92754 26.5022C6.92754 31.5328 6.76633 36.2609 7.95441 39.3194C10.8562 46.788 18.5323 46.0725 26.4912 46.0725C34.1695 46.0725 42.0864 46.8719 45.0301 39.3194C46.2337 36.2056 46.057 32.2616 46.057 26.5022C46.057 18.857 46.4788 13.9213 42.771 10.2158C39.0168 6.4616 33.9399 6.93197 26.4867 6.93197H26.4956ZM24.7422 10.4587C41.4681 10.4322 43.5969 8.57277 42.4221 34.4036C42.0047 43.5395 35.0485 42.5369 26.4978 42.5369C10.907 42.5369 10.4587 42.0909 10.4587 26.4934C10.4587 10.7148 11.6953 10.4675 24.7422 10.4543V10.4587ZM36.941 13.7071C35.6447 13.7071 34.5935 14.7583 34.5935 16.0546C34.5935 17.3509 35.6447 18.4021 36.941 18.4021C38.2373 18.4021 39.2885 17.3509 39.2885 16.0546C39.2885 14.7583 38.2373 13.7071 36.941 13.7071ZM26.4956 16.4521C20.946 16.4521 16.4477 20.9527 16.4477 26.5022C16.4477 32.0518 20.946 36.5501 26.4956 36.5501C32.0451 36.5501 36.5413 32.0518 36.5413 26.5022C36.5413 20.9527 32.0451 16.4521 26.4956 16.4521ZM26.4956 19.9788C35.1191 19.9788 35.1302 33.0256 26.4956 33.0256C17.8742 33.0256 17.861 19.9788 26.4956 19.9788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_1346",
    x1: 3.4141,
    y1: 49.6148,
    x2: 52.672,
    y2: 6.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_1346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3f263ad8ebf406cce1128c57a149b1a0.svg";
export { ForwardRef as ReactComponent };